import { __rest } from '../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { components } from 'react-select';
import { ReactComponent as SvgAngleLeftGray } from '../../assets/icons/sign/AngleLeftGray.svg.js';
import COLORS from '../../constants/colors.js';
import Typography from '../Typography/Typography.js';

const ContainerComponent = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(components.SelectContainer, Object.assign({}, props, { className: "select-container" }, { children: children })));
};
const ControlComponent = (_a) => {
    var _b;
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    const { selectProps } = props;
    const customLabel = (_b = selectProps["aria-label"]) !== null && _b !== void 0 ? _b : "";
    return (jsxs(components.Control, Object.assign({}, props, { className: [
            className,
            "select-control",
            selectProps.isSearchable ? "select-control--searchable" : null,
        ]
            .filter(Boolean)
            .join(" ") }, { children: [jsx(Typography, Object.assign({ weight: "medium", color: COLORS.GREY_600 }, { children: customLabel })), children] })));
};
const DropdownIndicatorComponentWrapper = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(components.DropdownIndicator, Object.assign({}, props, { className: "select-customDropDownIndicator" }, { children: children })));
};
const DropdownIndicatorComponent = (_a) => {
    var props = __rest(_a, ["children"]);
    return (jsx(components.DropdownIndicator, Object.assign({}, props, { className: "select-dropDownIndicator" }, { children: jsx(SvgAngleLeftGray, {}) })));
};
const SingleValueComponent = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { data: { leftNode, rightNode }, } = props;
    return (jsxs(components.SingleValue, Object.assign({}, props, { className: "select-singleValue" }, { children: [leftNode, jsx(Typography, Object.assign({ "data-select-value-label": true, size: "m" }, { children: children })), rightNode] })));
};
const InputComponent = (props) => {
    return jsx(components.Input, Object.assign({}, props, { className: "select-input" }));
};
const PlaceholderComponent = (props) => {
    return jsx(components.Placeholder, Object.assign({}, props, { className: "select-placeholder" }));
};
const ValueComponent = (props) => {
    return (jsx(components.ValueContainer, Object.assign({}, props, { className: "select-value-container" })));
};
const OptionComponent = (props) => {
    const { isDisabled, isSelected, isFocused, children, data: { leftNode, rightNode }, } = props;
    let state = "";
    if (isSelected) {
        state = "selected";
    }
    else if (isDisabled) {
        state = "disabled";
    }
    else if (isFocused) {
        state = "focused";
    }
    return (jsxs(components.Option, Object.assign({}, props, { className: `select-option ${state}` }, { children: [leftNode, " ", children, " ", rightNode] })));
};
const NoOptionsMessageComponent = (props) => {
    return (jsx(components.NoOptionsMessage, Object.assign({}, props, { className: "select-noOptionMessage" })));
};
const ClearIconComponent = (props) => {
    const { innerProps, selectProps: { instanceId }, } = props;
    return (jsx(components.ClearIndicator, Object.assign({}, props, { className: "select-clear", innerProps: Object.assign(Object.assign({}, innerProps), { id: `${instanceId}__clearBtn` }) })));
};

export { ClearIconComponent, ContainerComponent, ControlComponent, DropdownIndicatorComponent, DropdownIndicatorComponentWrapper, InputComponent, NoOptionsMessageComponent, OptionComponent, PlaceholderComponent, SingleValueComponent, ValueComponent };
//# sourceMappingURL=RSelectDerived.js.map
